import { Element } from "react-scroll";
import introPic from "../assets/images/profile.png";
import { Link as RouterLink } from "react-router-dom";

export default function HeroSection() {
  return (
    <Element className="section section--intro" name="hero">
      <div className="grid-container grid-container--split">
        <div className="section--intro__media">
          <img
            src={introPic}
            alt="Abdalla Saleh - Product Engineer"
            loading="lazy"
          />
        </div>

        <div className="section--intro__text">
          <span>
            Hi, I’m <strong>Abdalla Saleh</strong>
          </span>

          <h1>AI Product Engineer</h1>

          <p>
            With a foundation in UI/UX and frontend engineering, I build on my experience to create AI-powered products that combine thoughtful design, intelligent functionality, and real-world impact.
          </p>

          <div className="section--intro__buttons">
            <RouterLink
              className="section--intro__button-main"
              to="/contact"
            >
              Hire Me
            </RouterLink>

            <RouterLink
              className="section--intro__button-transparent"
              to="/about"
            >
              More About Me
            </RouterLink>
          </div>
        </div>
      </div>
    </Element>
  );
}